import axios from 'axios'
import LocalDataUtil from '@/utils/LocalDataUtil.js'
import API from '@/api/api.js'

const CMSKEY = 'cms_test'
const headers = {
  'application-key': CMSKEY,
  'language': 'ja'
}

export default class ApiClient {
  static getSession () {
    return LocalDataUtil.getSession()
  }

  static executeApi (url, method, data, query) {
    return axios({
      method: method,
      url: url,
      data: data,
      params: query,
      headers: headers
    }).then(response => {
      return response.data.data
    }).catch(err => {
      return err
    })
  }

  // ここでfactory methodのようなものを定義することで、dataだけ定義すればRequestを送れる
  static apiExecutionFactory (url, method, baseUrl = undefined) {
    return function (data = { param: {}, query: {}, pathParams: {} }) {
      let query = data.query
      let pathParams = data.pathParams
      // Path Parameterの指定
      let executeUrl = url
      if (pathParams !== undefined) {
        for (var key in pathParams) {
          executeUrl = executeUrl.replace('{' + key + '}', pathParams[key])
        }
      }
      // Request Paramterの指定
      let params
      if (method === 'post' || method === 'put') {
        params = new URLSearchParams()
        params.append('data', JSON.stringify(data.param))
      } else if (method === 'delete') {
        params = JSON.stringify({ 'data': data.param })
      } else {
        params = {}
      }

      // base urlに指定がある時
      if (baseUrl === undefined) {
        baseUrl = API.baseUrl()
      }

      // API実行
      return ApiClient.executeApi(
        baseUrl + executeUrl,
        method,
        params,
        query)
    }
  }
}
